import * as React from "react";

function ArrowTrendDownIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512",
    width: "1em",
    height: "1em",
    role: "img",
    fill: "currentColor",
    className: "anticon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M376 368h118.1L320 193.9 208.1 304.1c-8.5 10.2-23.7 10.2-33.1 0L7.029 136.1c-9.372-8.5-9.372-23.7 0-33.1 9.371-9.34 24.571-9.34 33.941 0L192 254.1 303 143c9.4-9.3 24.6-9.3 33.1 0L528 334.1V216c0-13.3 10.7-24 24-24s24 10.7 24 24v176c0 13.3-10.7 24-24 24H376c-13.3 0-24-10.7-24-24s10.7-24 24-24z"
  }));
}

const ForwardRef = React.forwardRef(ArrowTrendDownIcon);
export default ForwardRef;